import { gql } from "@apollo/client";

export const GET_REPORT_BY_ID = gql`
  query GetReportById($cId: ID!, $pId: ID!, $fileId: ID!) {
    getReportById(cId: $cId, pId: $pId, fileId: $fileId) {
      url
    }
  }
`;
